module.exports = __webpack_public_path__ + "media/parallax/separated-leaves-02-aa1a5bf7.svg";